f-dialog {
  .m-dialog {
    display: none;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    justify-content: center;
    align-items: center;
    max-width: 100% !important;

    &.-show-dialog {
      display: flex;
      background-color: rgba(191 192 194 / 0.3);
      z-index: 99999;
    }

    .a-box {
      position: fixed;

      z-index: 1000;
      box-shadow: 0 0 0.5rem 0.1rem var(--shadow-fill);

      .a-icon {
        margin: 0 10px 0 0;
        vertical-align: middle;
      }

      .a-button:first-child {
        margin-left: 0;
      }

      button:nth-last-child(2) {
        margin-left: auto;
      }

      .a-activity-indicator_background {
        margin-top: 30px;
      }
    }

    &__header {
      justify-content: space-between;
      padding-right: 0;

      &-title {
        display: flex;
        align-items: center;
        gap: 0.5rem;
      }
    }

    &__actions {
      justify-content: space-between;

      &-group {
        display: flex;
        gap: 1rem;
      }
    }
  }
}
